import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import WriteForUs from "../components/writeForUs"
import image from "../images/cookies-policy.svg"

const WriteFor = () => {
  const sectionData = {
    title: `Cookies Policy`,
    image,
    contents: [
      {
        title: "Cookies",
        content: `Our websites use cookies. Cookies are used by most websites and they do not harm your computer. They are small text files that are placed on your computer or mobile phone when you browse websites. Here are the types of cookies that we may use.`,
      },
      {
        title: "Strictly necessary cookies",
        content: `Some cookies on this site are essential and the site won’t work as expected without them. For example, they are set when you submit a form or interact with the site by doing something that goes beyond clicking on simple links. It also helps us to remember whether you have opted in or out of marketing activity.`,
      },
      {
        title: "Performance cookies",
        content: `These cookies remember information about how you use our website. They give us vital information like which pages are visited most often, whether customers are receiving error messages from certain pages, etc. These cookies allow us to analyse and improve the performance of our website. As a result, you receive a consistent look, feel and experience. Performance cookies or web analytic cookies don’t collect any identifiable user information. In addition, all information collected is aggregated and therefore anonymous.`,
      },
      {
        title: "Social Website Cookies",
        content: `Our site provides links to our blog and to our social media pages. Clicking on the links does not in itself mean that additional cookies will be placed. Please note, however, that once you interact with social networks, the privacy implications vary from social network to social network and are dependent on the specific privacy settings you have chosen on these networks.`,
      },
      {
        title: "Re-advertising cookies",
        content: `These cookies are used to deliver adverts that are more relevant to you and your interests. They are also used to limit the number of times you see an advertisement, as well as help measure the effectiveness of the advertising campaign. They are usually placed by advertising networks with the website operator’s permission. They remember that you have visited a website and this information is shared with other organisations such as advertisers. Quite often, targeting or advertising cookies will be linked to site functionality provided by the other organisation. Our site uses targeting cookies to run personalised Remarketing with LinkedIn, and Google Analytics to advertise online through the Google Display Network. If you want to stop the use of targeting cookies, please visit Google and change the settings. `,
      },
      {
        title: "Permission to use cookies",
        content: `A pop up will be displayed the first time that you visit our website. You can opt to accept or decline cookies at this point.`,
      },
      {
        title: "Deleting Cookies",
        content: `Some of the cookies we use are vital for the Wersel Workdesk website to function properly and have already been set. However, you can stop cookies from being placed on your computer by changing your browser settings not to accept them or opt out. The ‘help’ facility in your browser will show you how to do this. Please note, that restricting or deleting cookies will mean that our site may not work as you might expect.`,
      },
      {
        title: "Contact Information",
        content: [
          "We value your opinions. If you have questions or concerns with respect to our cookies policy, please feel free to",
          <a href="/contact"> contact us</a>,
          ".",
        ],
      },
    ],
  }
  return (
    <Layout withBrand slidePosition={0}>
      <SEO
        title="Write For Us – Wersel Workdesk"
        description="Welcome! We appreciate your interest in writing for Wersel. We are building a community of industry’s preeminent thought leaders and we want your voice."
        keywords="Data analytics write for us, big data write for us, write for us"
        url="www.wersel.io/write-for-us"
      />
      <WriteForUs sectionData={sectionData} />
    </Layout>
  )
}

export default WriteFor
